import {ReferenceNodeGenericTypeMap} from "~/enums/referenceNodeType"
import {GenericType} from '~/interfaces/genericTypeInterfaces';
import {IReferencePathNodeSpecific, IReferencePathNodeWorkflowGeneratedCert} from "~/interfaces/referencePathInterfaces";
import ReferencePathService from "~/services/referencePathServices/referencePathService";
import {ModelType} from '~/enums/modelType'
import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";

export class WorkflowGeneratedCertificatePathService extends ReferencePathService {
  get imposterModelType(): ModelType {
    return this.referenceGenericModelType
  }

  constructor(private workflowStepDataNode: IReferencePathNodeWorkflowGeneratedCert) {
    super();
  }

  get label(): string {
    return this.reference()?.certificate?.title || 'Generated Document';
  }

  get nodes(): IReferencePathNodeWorkflowGeneratedCert[] {
    return [this.workflowStepDataNode];
  }

  reference(): WorkflowStep {
    return WorkflowStep.repo.findById(this.workflowStepDataNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return ReferenceNodeGenericTypeMap[this.workflowStepDataNode.reference_type]
  }

  get referenceModelType(): ModelType {
    return this.referenceGenericModelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('WorkflowGeneratedCertificatePathService', this.workflowStepDataNode, node, decision)
    return decision
  }

  referenceIsCollection = false
}